var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidityCheckPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0006 9.91107L10.4485 8.8173C10.3395 8.77084 10.2183 8.76105 10.1032 8.78941C9.98816 8.81776 9.88541 8.88273 9.81046 8.97453L8.68023 10.3554C6.90645 9.51909 5.47895 8.0916 4.64263 6.31781L6.02351 5.18758C6.1155 5.11277 6.18061 5.01002 6.20898 4.8949C6.23735 4.77977 6.22743 4.65854 6.18074 4.54955L5.08697 1.99742C5.03573 1.87994 4.9451 1.78401 4.8307 1.72619C4.71631 1.66837 4.58532 1.65228 4.46034 1.68069L2.0905 2.22757C1.97 2.2554 1.86249 2.32325 1.78551 2.42005C1.70853 2.51685 1.66664 2.63688 1.66667 2.76056C1.66667 8.60539 6.40405 13.3337 12.2398 13.3337C12.3635 13.3337 12.4836 13.2919 12.5804 13.2149C12.6773 13.1379 12.7451 13.0304 12.773 12.9098L13.3199 10.54C13.3481 10.4144 13.3317 10.2829 13.2734 10.1681C13.2151 10.0533 13.1187 9.96242 13.0006 9.91107Z",
    fill: "#4FC3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidityCheckPhone);
export default __webpack_public_path__ + "static/media/validity-check-phone.06aad1e78fc230a323b2296891a2c38b.svg";
export { ForwardRef as ReactComponent };